import "./modalAprover.css";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import React from "react";

interface ModalProps {
  titleModal?: string;
  titleDescription?: React.ReactNode;
  bodyModal?: React.ReactNode;
  buttonOne?: string;
  buttonTwo?: string;
  buttonThree?: string;
  onLogout?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  isSubmitting: boolean;
}

export const ModalAprover = ({
  titleModal,
  titleDescription,
  bodyModal,
  buttonOne,
  buttonTwo,
  buttonThree,
  onClose,
  onConfirm,
  onLogout,
  className,
  isSubmitting,
}: ModalProps) => {
  return (
    <div
      className={`modalCorporateSession ${className}`}
      data-testid="modal-aprover"
    >
      <div className="modal">
        <div>
          <div className="containerTitleModal">
            {titleModal && <h1 className="titleModal">{titleModal}</h1>}
          </div>
          <div className="containerDescription">
            {titleDescription && (
              <span className="bodyModal">{titleDescription}</span>
            )}

            {bodyModal && (
              <span className="bodyModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            )}

            <div className="buttonsEdit">
              {buttonOne && (
                <ButtonGeneric
                  style="buttonGenericCustom buttonGeneric buttonHover"
                  title={buttonOne}
                  colorTitle="#fff"
                  onClick={onConfirm}
                  disabled={isSubmitting}
                />
              )}
              {buttonTwo && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonTwo}
                  colorTitle="#007BC0"
                  onClick={onClose}
                />
              )}
              {buttonThree && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonThree}
                  colorTitle="#007BC0"
                  onClick={onLogout}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAprover;
